/*
 * @Description: 
 * @Autor: jyf
 * @Date: 2022-03-31 14:34:49
 * @LastEditors: jyf
 * @LastEditTime: 2022-04-11 10:38:30
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace Kpi {
    /**
    * 获取列表
    */
    export var GetKpiList = (query: any): Promise<any> => {
        return Get(`/msls/Kpi/GetKpiList?${qs.stringify(query)}`, {});
    };
    /**
* 获取详情列表
*/
    export var GetKpiDetailList = (query: any): Promise<any> => {
        return Get(`/msls/Kpi/GetKpiDetailList?${qs.stringify(query)}`, {});
    };

    /**
* 获取画像
*/
    export var GetCarrierPortrait = (query: any): Promise<any> => {
        return Get(`/msls/Kpi/GetCarrierPortrait?${qs.stringify(query)}`, {});
    };

    /**
    * 删除
    */
    export var DelKpi = (id: string): Promise<any> => {
        return Delete(`/msls/Kpi/Delete/${id}`, {});
    };


    /**
    * 新增
    */
    export var AddKpi = (body: any): Promise<any> => {
        return Post(`/msls/Kpi/Add`, body);
    };


    export var Export = (query: any): Promise<any> => {
        return Download(`/msls/Kpi/Export?${qs.stringify(query)}`, {});
    };



}
